/* =====================================================================
   Bluewud — multi-step contact form guard (Become a Dealer / Bulk Orders).

   THE BUG (verified live on /pages/become-dealer):
   Both forms are 2-step. Step 2 is hidden with [hidden] while it still holds
   `required` selects (business_type / years / volume on dealer; the equivalents
   on bulk). A `required` control inside a hidden container cannot be focused, so
   the browser ABORTS submission with:
       "An invalid form control with name='contact[business_type]' is not focusable"
   ...and the form silently does nothing. Pressing Enter in any step-1 field
   triggers exactly this (implicit submission), which is why filling the form and
   submitting appeared to "throw errors" / do nothing — and why dealer and bulk
   leads were being lost.

   THE FIX:
     1. Only the VISIBLE step carries `required`, so the browser only ever
        validates fields the shopper can actually see and reach.
     2. While the last step is still hidden, an implicit submit (Enter) ADVANCES
        to the next step instead of posting a half-filled form.

   Step-1 values still post normally — [hidden] hides a field, it does not
   disable it, so nothing is lost from the submission.
   ===================================================================== */
(function () {
  'use strict';

  var STEP_ATTRS = ['data-bluewud-dealer-step', 'data-bluewud-bulk-step'];
  var NEXT_SEL = '[data-bluewud-dealer-next], [data-bluewud-bulk-next]';

  function stepsOf(form) {
    for (var i = 0; i < STEP_ATTRS.length; i++) {
      var els = form.querySelectorAll('[' + STEP_ATTRS[i] + ']');
      if (els.length) return Array.prototype.slice.call(els);
    }
    return [];
  }

  function isHidden(step) {
    return step.hidden || step.offsetParent === null;
  }

  // Move `required` on/off so it only ever lives on the visible step.
  function sync(form) {
    stepsOf(form).forEach(function (step) {
      var hide = isHidden(step);
      var fields = step.querySelectorAll('input, select, textarea');
      Array.prototype.forEach.call(fields, function (el) {
        if (hide) {
          if (el.required) {
            el.setAttribute('data-bw-req', '1');
            el.required = false;
          }
        } else if (el.getAttribute('data-bw-req')) {
          el.required = true;
          el.removeAttribute('data-bw-req');
        }
      });
    });
  }

  function lastStepHidden(form) {
    var steps = stepsOf(form);
    var last = steps[steps.length - 1];
    return !!(last && isHidden(last));
  }

  function advance(form) {
    var next = form.querySelector(NEXT_SEL);
    if (next) next.click();
  }

  // ---- Multi-select checkbox groups ---------------------------------------
  // Shopify's contact form only accepts FLAT string values. Posting
  // `contact[current_categories][]` sends an array, which Shopify rejects with
  // "Current_categories is invalid" and the whole submission fails. So the
  // checkboxes post nothing themselves (name="bw_multi_*"), and we mirror each
  // group into ONE comma-joined `contact[<group>]` hidden field before submit.
  function syncMulti(form) {
    var boxes = form.querySelectorAll('[data-bw-multi]');
    if (!boxes.length) return;
    var groups = {};
    Array.prototype.forEach.call(boxes, function (b) {
      var g = b.getAttribute('data-bw-multi');
      if (!groups[g]) groups[g] = [];
      if (b.checked) groups[g].push(b.value);
    });
    Object.keys(groups).forEach(function (g) {
      var hidden = form.querySelector('input[type="hidden"][data-bw-multi-out="' + g + '"]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.setAttribute('data-bw-multi-out', g);
        hidden.name = 'contact[' + g + ']';
        form.appendChild(hidden);
      }
      hidden.value = groups[g].join(', ');
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('form'), function (form) {
      if (form.__bwStepGuard || (!stepsOf(form).length && !form.querySelector('[data-bw-multi]'))) return;
      form.__bwStepGuard = true;

      sync(form);
      syncMulti(form);
      form.addEventListener('change', function (e) {
        if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-bw-multi')) syncMulti(form);
      });

      // The section's own next/back toggles [hidden]; re-sync when it does.
      if (window.MutationObserver) {
        var mo = new MutationObserver(function () { sync(form); });
        stepsOf(form).forEach(function (s) {
          mo.observe(s, { attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
        });
      }

      // Enter on an early step must advance, never post a half-filled form.
      form.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.keyCode !== 13) return;
        if (e.target && e.target.tagName === 'TEXTAREA') return;
        if (lastStepHidden(form)) {
          e.preventDefault();
          advance(form);
        }
      });

      form.addEventListener('submit', function (e) {
        if (lastStepHidden(form)) {
          e.preventDefault();
          advance(form);
          return;
        }
        syncMulti(form); // final mirror of the checkbox groups before posting
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
